import React, {Component} from 'react';
import {connect} from 'react-redux';
import {toastr} from 'react-redux-toastr';
import {withStyles} from 'material-ui/styles';
import styles from './style/styles';
import BlockEditForm from './forms/EditBlockForm';
import {fetchBlockTypes, updateBlock} from './thunks';
import {
    fetchDestinations,
    fetchTripFormats,
    fetchTypesOfWork,
} from '../taxonomy/thunks';
import {
    changeBlockType,
    changeBlockDestination,
    changeBlockTripFormat,
    changeBlockTypeOfWork,
    changeBlockName,
    changeBlockTitle,
    changeBlockBody,
    changeBlockButtonText,
    updateVideoUrlField,
    updateImagesInTheBlockEdit,
    selectImageSettingInTheBlockEdit,
    selectVideoSettingInTheBlockEdit,
    deleteImageInTheBlockEdit,
    updateCroppedImageInTheBlockEdit,
    updateThumbCroppedImageInTheBlockEdit,
    updateImageMetaInTheBlockEdit,
    updateBlockImagesSortOrder,
    togglePagePickerPopup,
    onPickBlockPage,
} from './actions';
import {onSearchPages} from '../page-picker/thunks';
import {fetchImageSettings, fetchVideoSettings} from '../pages/settings/thunks';
import {fetchImageRatios} from '../images/thunks';
import {SECTION_TYPE_BLOCK} from '../builder/constants';
import {showErrMsgPopup} from '../../components/helpers/helpers';
import {BLOCK_TYPE_ACCREDITATION_ID} from './types';

class BlockEditContent extends Component {
    componentWillMount() {
        this.props.fetchDestinations();
        this.props.fetchBlockTypes();
        this.props.fetchTripFormats();
        this.props.fetchTypesOfWork();
        this.props.fetchImageSettings();
        this.props.fetchVideoSettings();
        this.props.fetchImageRatios();
    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextProps.loading !== true;
    }

    componentWillUnmount() {
        toastr.removeByType('error');
    }

    handleEditBlockSubmit = () => {
        const {block, pagePicker} = this.props;
        const message = this.imagesAreCropped(block.images);
        message === true
            ? this.props.updateBlock({...block, page: pagePicker.page})
            : showErrMsgPopup(message);
    };

    imagesAreCropped(images) {
        // don't force images crop if block is accreditations
        if (this.props.block.block_type_id === BLOCK_TYPE_ACCREDITATION_ID)
            return true;

        let imagesAreCropped = true;
        let imagesToBeCropped = '';

        images.map((image, index) => {
            if (image.new && !image.deleted && !image.croppedImage) {
                imagesAreCropped = false;
                imagesToBeCropped += image.name + '\n';
            }

            return imagesAreCropped;
        });

        if (imagesAreCropped) {
            return true;
        }

        let message = 'Cropping the block images is mandatory!\n';
        message += 'Following images need to be cropped:\n\n';
        message += imagesToBeCropped;

        return message;
    }

    getSettings(allSettings) {
        return allSettings.filter(
            (setting) => Number(setting.section_type_id) === SECTION_TYPE_BLOCK
        );
    }

    render() {
        const imageSettings = this.getSettings(this.props.allImageSettings);
        const videoSettings = this.getSettings(this.props.allVideoSettings);

        const {pagePicker} = this.props;

        return (
            !this.props.loading && (
                <BlockEditForm
                    block={this.props.block}
                    destinations={this.props.destinations}
                    blockTypes={this.props.blockTypes}
                    tripFormats={this.props.tripFormats}
                    typesOfWork={this.props.typesOfWork}
                    initialValues={this.props.initialValues}
                    handleFormSubmit={this.handleEditBlockSubmit.bind(this)}
                    classes={this.props.classes}
                    touched={this.props.touched}
                    loading={this.props.loading}
                    blockTypeId={this.props.blockTypeId}
                    blockDestinationId={this.props.blockDestinationId}
                    blockTripFormatId={this.props.blockTripFormatId}
                    blockTypeOfWorkId={this.props.blockTypeOfWorkId}
                    pageId={this.props.block.page_id}
                    buttonText={this.props.block.button_text}
                    name={this.props.name}
                    title={this.props.title}
                    body={this.props.body}
                    blockName={this.props.blockName}
                    onChangeBlockType={this.props.changeBlockType}
                    onChangeBlockDestination={this.props.changeBlockDestination}
                    onChangeBlockTripFormat={this.props.changeBlockTripFormat}
                    onChangeBlockTypeOfWork={this.props.changeBlockTypeOfWork}
                    onChangeBlockName={this.props.changeBlockName}
                    onChangeBlockTitle={this.props.changeBlockTitle}
                    onChangeBlockBody={this.props.changeBlockBody}
                    onChangeBlockButtonText={this.props.changeBlockButtonText}
                    onPickBlockPage={this.props.onPickBlockPage}
                    allPagesBySearchCriteria={
                        this.props.allPagesBySearchCriteria
                    }
                    togglePagePickerPopup={this.props.togglePagePickerPopup}
                    pageSearchCriteria={this.props.pageSearchCriteria}
                    onSearchPages={this.props.onSearchPages}
                    pagePickerPopupOpen={pagePicker.popupOpen}
                    pagePickerPage={pagePicker.page}
                    imageSettings={imageSettings}
                    videoSettings={videoSettings}
                    imageRatios={this.props.imageRatios.text}
                    selectedImageSettings={this.props.selectedImageSettings}
                    selectedVideoSettings={this.props.selectedVideoSettings}
                    selectImageSetting={(selectedOptions, forSetting) => {
                        this.props.selectImageSetting(
                            selectedOptions,
                            forSetting
                        );
                    }}
                    selectVideoSetting={(selectedOptions, forSetting) => {
                        this.props.selectVideoSetting(
                            selectedOptions,
                            forSetting
                        );
                    }}
                    onUpdateImagesField={(images) =>
                        this.props.updateImagesBlockFields(images)
                    }
                    onDeleteImageField={(image, index) =>
                        this.props.deleteImage(image, index)
                    }
                    onCropImage={(
                        index,
                        image,
                        imageUrlBlob,
                        imageBlobObject
                    ) => {
                        this.props.updateCroppedImage(
                            index,
                            image,
                            imageUrlBlob,
                            imageBlobObject
                        );
                    }}
                    onCropThumbImage={(
                        index,
                        image,
                        imageUrlBlob,
                        imageBlobObject
                    ) => {
                        this.props.updateThumbCroppedImage(
                            index,
                            image,
                            imageUrlBlob,
                            imageBlobObject
                        );
                    }}
                    onImageMetaUpdate={(index, imageMeta) => {
                        this.props.updateImageMeta(index, imageMeta);
                    }}
                    onUpdateImagesSortOrder={(images) =>
                        this.props.updateBlockImagesSortOrder(images)
                    }
                    onUpdateVideoUrlField={(id, url) =>
                        this.props.updateVideoUrlField(id, url)
                    }
                    onSubmit={this.handleEditBlockSubmit}
                />
            )
        );
    }
}

const mapStateToProps = (state, props) => ({
    block: state.blocks.block,
    destinations: state.taxonomy.allDestinations,
    blockTypes: state.blocks.allBlockTypes,
    tripFormats: state.taxonomy.allTripFormats,
    typesOfWork: state.taxonomy.allTypesOfWork,
    blockTypeId: state.blocks.block.block_type_id,
    blockDestinationId: state.blocks.block.destination_id,
    blockTripFormatId: state.blocks.block.trip_format_id,
    blockTypeOfWorkId: state.blocks.block.type_of_work_id,
    name: state.blocks.block.display_name,
    title: state.blocks.block.title,
    body: state.blocks.block.body,
    touched: state.blocks.touched,
    loading: state.layout.ajaxCallsInProgress > 0,
    selectedImageSettings: state.blocks.block.imageSettings,
    selectedVideoSettings: state.blocks.block.videoSettings,
    imageRatios: state.images.ratios,
    allImageSettings: state.sectionsSettings.imageSettings,
    imageSettings: state.sectionsSettings.imageSettings,
    allVideoSettings: state.sectionsSettings.videoSettings,
    videoSettings: state.sectionsSettings.videoSettings,
    blockName: state.blocks.blockName,
    allPagesBySearchCriteria: state.pagePicker.allPagesBySearchCriteria,
    pageSearchCriteria: state.pagePicker.pageSearchCriteria,
    pagePicker: state.blocks.pagePicker,
});

export default connect(mapStateToProps, {
    fetchDestinations,
    fetchBlockTypes,
    fetchTripFormats,
    fetchTypesOfWork,
    updateBlock,
    changeBlockType,
    changeBlockDestination,
    changeBlockTripFormat,
    changeBlockTypeOfWork,
    changeBlockName,
    changeBlockTitle,
    changeBlockBody,
    changeBlockButtonText,
    updateVideoUrlField,
    selectImageSetting: selectImageSettingInTheBlockEdit,
    selectVideoSetting: selectVideoSettingInTheBlockEdit,
    updateImagesBlockFields: updateImagesInTheBlockEdit,
    deleteImage: deleteImageInTheBlockEdit,
    updateCroppedImage: updateCroppedImageInTheBlockEdit,
    updateThumbCroppedImage: updateThumbCroppedImageInTheBlockEdit,
    updateImageMeta: updateImageMetaInTheBlockEdit,
    updateBlockImagesSortOrder,
    fetchImageSettings,
    fetchVideoSettings,
    fetchImageRatios,
    togglePagePickerPopup,
    onPickBlockPage,
    onSearchPages,
})(withStyles(styles)(BlockEditContent));



// WEBPACK FOOTER //
// ./src/containers/blocks/BlockEditContent.jsx